import React from 'react'
import PropTypes from 'prop-types'
import {
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  AreaChart,
  Area
} from 'recharts'
import ChartLegend from '../ChartLegend/ChartLegend.component'
import renderTooltip from 'analytics/components/Chart/Tooltip/Tooltip.component'
import moment from 'moment'
import setChartColor from 'shared/utils/chart/setChartColor'

const renderChartLegend = parentProps => props => <ChartLegend {...parentProps} {...props} />

const toPercent = (decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`

const dataPreAggregator = data => {
  console.log(data)
  return data
}

const CartesianChart = props => {
  const {
    resultSet,
    children,
    ChartComponent,
    dimensions
  } = props

  const data = resultSet.chartPivot()

  return (
    <ResponsiveContainer width='100%' height={500}>
      <ChartComponent data={dataPreAggregator(data)}>
        <XAxis
          dataKey='x'
          tickFormatter={(label) => moment(label).format('MMM D')}
        />
        <YAxis
          // allowDecimals={false}
          // type="number"
          // domain={[-1, 1]}
          // tick={<SentimentTick />}
          // unit="%"
          tickFormatter={toPercent}
        />
        <CartesianGrid />
        { children }
        <Legend
          layout='vertical'
          verticalAlign='top'
          align='center'
          content={renderChartLegend(props)}
          dimensions={dimensions}
        />
        <Tooltip
          cursor={false}
          content={renderTooltip()}
        />
      </ChartComponent>
    </ResponsiveContainer>
  )
}

CartesianChart.propTypes = {
  resultSet: PropTypes.any,
  children: PropTypes.any,
  ChartComponent: PropTypes.any,
  dimensions: PropTypes.array
}

const SentimentTick = props => {
  const { x, y, payload } = props

  console.log(payload.value)

  if(payload.value === 1) {
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={2} textAnchor="end" fontSize="20">😀</text>
      </g>
    )
  }
  if(payload.value === -1) {
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={-8} textAnchor="end" fontSize="20">🙁️</text>
      </g>
    )
  }
  return null
}

SentimentTick.propTypes = {
  x: PropTypes.any,
  y: PropTypes.any,
  payload: PropTypes.any
}

const sentimentsRender = props => (
  <CartesianChart
    resultSet={props.resultSet}
    ChartComponent={AreaChart}
    {...props}
  >
    {props.resultSet.seriesNames().map(series => {
      const lineColor = setChartColor({ 
        type: [ 'sentiment' ], 
        key: series.key 
      })

      return (
        <Area
          type='monotone'
          key={series.key}
          stackId="a"
          dataKey={series.key}
          name={series.title}
          fill={lineColor}
          stroke={lineColor}
        />
      )
    })}
  </CartesianChart>
)

sentimentsRender.propTypes = {
  resultSet: PropTypes.object,
  chartType: PropTypes.string,
  granularity: PropTypes.string,
  dateRange: PropTypes.string,
  customDateRange: PropTypes.object,
  channelNameToFilter: PropTypes.string,
  onChangeChartType: PropTypes.func,
  onChangeGranularity: PropTypes.func,
  onMoveCustomDateRange: PropTypes.func
}

export default sentimentsRender
